import { render, staticRenderFns } from "./SendDocumentModal.vue?vue&type=template&id=a1ba9868&scoped=true&"
import script from "./SendDocumentModal.vue?vue&type=script&lang=js&"
export * from "./SendDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./SendDocumentModal.vue?vue&type=style&index=0&id=a1ba9868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ba9868",
  null
  
)

export default component.exports